import React from 'react'
import mediaVersionPropTypes from '@/shape/media-version'
import { arrayOf, shape, bool } from 'prop-types'
import styles from './MediaVersions.module.scss'
import Expander from '@/component/Primitive/Expander'
import MediaVersionContent from './component/MediaVersionContent'
import classNames from 'classnames'
import moment from 'moment'
import formatDuration from './duration-formatter'
import Type from '@/component/Primitive/Type'
import RatingColor from '../RatingColor'
import ContentAdvice from '@/component/Primitive/ContentAdvice/ContentAdvice'

const MediaVersions = ({ details, designV2 }) => {
  const formatSubtitle = (seconds, date) => {
    if (seconds && date)
      return (
        <>
          <span className={styles.Subtitle_time}>
            {formatDuration(seconds)}
          </span>{' '}
          |{' '}
          <span className={styles.Subtitle_year}>
            {moment(date).format('YYYY')}
          </span>
        </>
      )
    if (seconds)
      return (
        <span className={styles.Subtitle_time}>{formatDuration(seconds)}</span>
      )
    if (date)
      return (
        <span className={styles.Subtitle_year}>
          {moment(date).format('YYYY')}
        </span>
      )
    return ''
  }

  return (
    <div className={styles.MediaVersions}>
      {details.map((release, i) => {
        const {
          classification,
          classificationDate,
          durationSeconds,
          title,
          version,
          cutsSummary,
          visualAdviceLayer,
          shortFormInsight,
          nonDefiningIssues
        } = release

        return (
          <Expander
            key={`MediaVersion_${title}_${durationSeconds}_${i}`}
            classification={classification}
            title={title}
            version={version}
            cutsSummary={cutsSummary}
            subtitle={formatSubtitle(durationSeconds, classificationDate)}
            className={classNames(
              styles.Expander,
              i % 2 !== 0 && styles.hasDarkerBackground
            )}
            classNames={{
              icon: styles.Icon,
              title: styles.Title,
              subtitle: styles.Subtitle
            }}
            options={{
              classificationFirst: true,
              spacious: true,
              titlesStacked: true,
              iconConfig: {
                open: 'plus',
                close: 'minus'
              }
            }}
          >
            {shortFormInsight && (
              <Type className={styles.SRISubtitle} size="subtitle">
                <RatingColor
                  property="color"
                  className={styles.Themes}
                  rating={classification}
                >
                  <span>{shortFormInsight}</span>
                </RatingColor>
              </Type>
            )}
            <MediaVersionContent details={release} designV2={designV2} />
            {visualAdviceLayer &&
              visualAdviceLayer.details &&
              visualAdviceLayer.details.length > 0 && (
                <Expander
                  title="Content Advice"
                  className={styles.RatingsExpander}
                  classNames={{
                    title: styles.RatingsExpander_title,
                    icon: styles.RatingsExpander_icon
                  }}
                >
                  {visualAdviceLayer && (
                    <ContentAdvice
                      showDescription
                      data={visualAdviceLayer.details}
                      showOnMobile
                      hideDots
                      primaryAssetNonDefiningIssues={nonDefiningIssues}
                    />
                  )}
                </Expander>
              )}
          </Expander>
        )
      })}
    </div>
  )
}

MediaVersions.propTypes = {
  details: arrayOf(shape(mediaVersionPropTypes)),
  designV2: bool
}

export default MediaVersions
